// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "categories-landing-" + (chunkId === 226 ? "webfooter-Footer" : chunkId) + "-st-" + {"139":"87735d8c","213":"d48b7073","226":"a4cf1348","249":"79c17903","313":"93ab653e","790":"157b48be","846":"c67df23f"}[chunkId] + ".js";
};